export const EXPIRE_DATE = '2023-11-09 00:00:00';
export const LOGGED_IN_REDIRECT_URL = "/black-friday";
export const GUEST_REDIRECT_URL = "/account/login";
